import * as Showdown from 'showdown';

export const converter = new Showdown.Converter({
  tables: true,
  simplifiedAutoLink: true,
  strikethrough: true,
  tasklists: true,
});

export const languagesFlagsRefs = {
  'fr-FR': 'fr',
  'en-GB': 'gb-eng',
  'es-ES': 'es',
};

export const mppChampionshipLabel = {
  1: 'Ligue 1',
  4: 'Ligue 2',
  6: 'Ligue des champions',
  8: 'Coupe du monde',
  9: 'Euro',
  19: 'CAN',
};



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/MPPCreateChallengeEditor/utils.ts